import { render, staticRenderFns } from "./Clearanceapplication.vue?vue&type=template&id=50b4bec1&scoped=true&"
import script from "./Clearanceapplication.vue?vue&type=script&lang=js&"
export * from "./Clearanceapplication.vue?vue&type=script&lang=js&"
import style0 from "./Clearanceapplication.vue?vue&type=style&index=0&id=50b4bec1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b4bec1",
  null
  
)

export default component.exports